import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { GrubhubSeamlessPlusControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusControl/GrubhubSeamlessPlusControl';
import { MembershipPayerOptionsControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/MembershipPayerOptionsControl/MembershipPayerOptionsControl';
import { MembershipFeeControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/MembershipFeeControl/MembershipFeeControl';
import { TrialLengthControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/TrialLengthControl/TrialLengthControl';
import { useGrubhubSeamlessPlusWrapper } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/hooks/useGrubhubSeamlessPlusWrapper';
import { MembershipFeeSelectControl } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/MembershipFeeSelectControl/MembershipFeeSelectControl';
import { MembershipFeeSelectDisplay } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/MembershipFeeSelectControl/MembershipFeeSelectDisplay';

export function GrubhubSeamlessPlusWrapper(): JSX.Element {
  const {
    showCorpFundingControls,
    showMembershipPayerOptions,
    showTrialLengthControl,
    fundingOptionsDisabled,
    trialPeriodRange,
    showEmployeeFundedControls,
    disabledCorpFunding,
    showMembershipFeeSelectReadOnly,
  } = useGrubhubSeamlessPlusWrapper();
  return (
    <>
      <GrubhubSeamlessPlusControl name="ghPlusEnabled" id="ghPlusEnabled" />
      {showMembershipPayerOptions && (
        <>
          <MembershipPayerOptionsControl
            disabled={fundingOptionsDisabled}
            disabledCorpFunding={disabledCorpFunding}
            name="ghPlusSubscription.funding"
            id="membershipPayerOptions"
          />
          {showCorpFundingControls && (
            <>
              <Stack y="sm">
                <MembershipFeeControl
                  name="ghPlusSubscription.monthlyFeeField"
                  id="membershipMonthlyFee"
                />
              </Stack>
              {showTrialLengthControl && (
                <Stack y="sm">
                  <TrialLengthControl
                    name="ghPlusSubscription.trialLengthDays"
                    id="trialLength"
                  />
                </Stack>
              )}
            </>
          )}
          {showEmployeeFundedControls && (
            <Stack y="sm">
              <MembershipFeeSelectControl
                name="ghPlusSubscription.monthlyFeeSelect"
                id="membershipMonthlyFeeSelect"
              />
            </Stack>
          )}
          {showMembershipFeeSelectReadOnly && (
            <Stack y="sm">
              <MembershipFeeSelectDisplay
                name="ghPlusSubscription.monthlyFeeSelect"
                id="membershipMonthlyFeeSelectDisplay"
              />
            </Stack>
          )}
          <Stack y="xx-sm">
            <Copy variant="body" color="secondaryText">
              Length of free trial
            </Copy>
          </Stack>
          <Stack>{trialPeriodRange}</Stack>
        </>
      )}
    </>
  );
}
